<script>
/* eslint-disable */
import InlineFileUpload from "./uploads/InlineFileUpload.vue";
export default {
  props: ["video", "index"],
  data() {
    return {
      shortDescriptionLimitCount: 500,
      longDescriptionLimitCount: 500,
      editThumbnail: false,
      editLandscapeThumbnail: false,
    };
  },
  components: {
    InlineFileUpload,
  },
  computed: {
    title_card: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "title_card",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.title_card;
        }
        return "";
      },
    },
    rendered: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "rendered",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.rendered;
        }
        return "";
      },
    },
    uploaded: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "uploaded",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.uploaded;
        }
        return "";
      },
    },
    txt_code: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "txt_code",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.txt_code;
        }
        return "";
      },
    },

    project_location: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "project_location",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.project_location;
        }
        return "";
      },
    },

    file_location: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "file_location",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.file_location;
        }
        return "";
      },
    },

    thumbnail: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "thumbnail",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.thumbnail;
        }
        return "";
      },
    },

    landscape_thumbnail: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "landscape_thumbnail",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.landscape_thumbnail;
        }
        return "";
      },
    },
    brightcove_id: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "brightcove_id",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.brightcove_id;
        }
        return "";
      },
    },
  },

  methods: {
    handleFileUploaded(file) {
      this.thumbnail = file;
      this.editThumbnail = false;
    },
    editThumbnailFunc() {
      this.editThumbnail = true;
    },
    handleLandscapeFileUploaded(file) {
      this.landscape_thumbnail = file;
      this.editLandscapeThumbnail = false;
      console.log(this.landscape_thumbnail);
      console.log(this.editLandscapeThumbnail);
    },
    editLandscapeThumbnailFunc() {
      this.editLandscapeThumbnail = true;
    },
    tabStatus(status) {
      this.$store.commit(`workouts/setTabStatus`, status);
    },
  },
  watch: {
    title_card() {
      this.tabStatus(true);
    },
    rendered() {
      this.tabStatus(true);
    },
    uploaded() {
      this.tabStatus(true);
    },
    txt_code() {
      this.tabStatus(true);
    },
    project_location() {
      this.tabStatus(true);
    },
    file_location() {
      this.tabStatus(true);
    },
    thumbnail() {
      this.tabStatus(true);
    },
    landscape_thumbnail() {
      this.tabStatus(true);
    },
    brightcove_id() {
      this.tabStatus(true);
    },
  },
};
</script>
<template>
  <div class="mb-5" v-if="!video.hidden">
    <div class="card bg-light border px-4 py-4">
      <div class="card-body">
        <span class="bg-dark text-white badge inline-block mr-1">{{
          video.render_type
        }}</span>
        <span class="inline-block">ID {{ video.id }}</span>
        <h2 class="my-3 mb-3 text-uppercase">{{ video.xali_title }}</h2>
        <div class="d-flex">
          <b-form-checkbox v-model="title_card" switch class="mr-3">
            Title Card
          </b-form-checkbox>
          <b-form-checkbox v-model="rendered" switch class="mr-3">
            Rendered
          </b-form-checkbox>
          <b-form-checkbox v-model="uploaded" switch class="mr-3">
            Uploaded
          </b-form-checkbox>
        </div>
        <b-form-group label="VTT FILE LOCATION" label-for="txt_code">
          <b-form-input
            id="txt_code"
            placeholder="Eg: Enter VTT File location here..."
            v-model="txt_code"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="FILE LOCATION" label-for="file_location">
          <b-form-input
            id="file_location"
            placeholder="Eg: Enter file location here..."
            v-model="file_location"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="BRIGHTCOVE ID" label-for="brightcove_id">
          <b-form-input
            id="brightcove_id"
            placeholder="Eg: Enter brightcoveID here..."
            v-model="brightcove_id"
          ></b-form-input>
        </b-form-group>
        <!-- <div class="d-flex">
          <div class="mr-4">
            <label for="uploader"> PORTRAIT </label>
            <div class="" style="width: 300px">
              <div
                v-if="thumbnail && !editThumbnail"
                class="portrait image-wrapper"
                :style="{
                  backgroundImage: 'url(\'' + thumbnail + '\')',
                  marginTop: '0px',
                }"
              >
                <button @click="editThumbnailFunc()" class="edit">
                  <b-icon icon="pencil" />
                </button>
              </div>
              <inline-file-upload
                v-if="!thumbnail || editThumbnail"
                :allowMultipleUploads="false"
                v-on:file-uploaded="handleFileUploaded"
              >
              </inline-file-upload>
            </div>
          </div>

          <div class="">
            <label for="uploader"> LANDSCAPE </label>
            {{ landscape_thumbnail }}
            <div class="" style="width: 300px">
              <div
                v-if="landscape_thumbnail && !editLandscapeThumbnail"
                class="portrait image-wrapper"
                :style="{
                  backgroundImage: 'url(\'' + landscape_thumbnail + '\')',
                  marginTop: '0px',
                }"
              >
                <button @click="editLandscapeThumbnailFunc()" class="edit">
                  <b-icon icon="pencil" />
                </button>
              </div>
              <inline-file-upload
                v-if="!landscape_thumbnail || editLandscapeThumbnail"
                :allowMultipleUploads="false"
                v-on:file-uploaded="handleLandscapeFileUploaded"
              >
              </inline-file-upload>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>